import {
  GET_MAIL_SERVICES_FAILURE,
  GET_MAIL_SERVICES_STARTED,
  GET_MAIL_SERVICES_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_STARTED,
  GET_SETTINGS_SUCCESS,
  GET_TIME_ZONES_FAILURE,
  GET_TIME_ZONES_STARTED,
  GET_TIME_ZONES_SUCCESS,
  LOGIN_DEFAULT,
} from "redux/ActionTypes";
// --------------------------------------------------------------------------------
const initialState = {
  rType: LOGIN_DEFAULT,
  timeZones: [],
  mailServices: [],
  settings: {},
  error: "",
};
export const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TIME_ZONES_STARTED:
    case GET_MAIL_SERVICES_STARTED:
    case GET_SETTINGS_STARTED:
      return {
        ...state,
        rType: action.type,
        error: "",
      };
    case GET_TIME_ZONES_SUCCESS:
      return {
        ...state,
        rType: GET_TIME_ZONES_SUCCESS,
        timeZones: action.payload.timeZones,
        error: "",
      };
    case GET_MAIL_SERVICES_SUCCESS:
      return {
        ...state,
        rType: GET_MAIL_SERVICES_SUCCESS,
        mailServices: action.payload.mailServices,
        error: "",
      };
    case GET_TIME_ZONES_SUCCESS:
      return {
        ...state,
        rType: GET_TIME_ZONES_SUCCESS,
        timeZones: action.payload.timeZones,
        error: "",
      };
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        rType: GET_SETTINGS_SUCCESS,
        settings: action.payload.settings,
        error: "",
      };
    case GET_TIME_ZONES_FAILURE:
    case GET_MAIL_SERVICES_FAILURE:
    case GET_SETTINGS_FAILURE:
      return {
        ...state,
        rType: action.type,
        error: action.payload,
      };
    default:
      return state;
  }
};
